import { useState, useEffect, useCallback } from "react";
import { useLogout } from "./useLogout";

/**
 * Custom hook for user menu functionality
 * Follows SRP: Single responsibility for user menu state
 * Follows DIP: Depends on useLogout abstraction
 */
export const useUserMenu = () => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { handleLogout } = useLogout();

  /**
   * Handle sign out with menu close
   */
  const handleSignOut = useCallback(async () => {
    setUserMenuOpen(false);
    await handleLogout();
  }, [handleLogout]);

  /**
   * Toggle user menu state
   */
  const toggleUserMenu = useCallback(() => {
    setUserMenuOpen((prev) => !prev);
  }, []);

  /**
   * Close user menu
   */
  const closeUserMenu = useCallback(() => {
    setUserMenuOpen(false);
  }, []);

  /**
   * Handle click outside to close menu
   */
  useEffect(() => {
    const handleClickOutside = () => setUserMenuOpen(false);

    if (userMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [userMenuOpen]);

  return {
    userMenuOpen,
    handleSignOut,
    toggleUserMenu,
    closeUserMenu,
  };
};
